<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">{{ appName }}设备权限清单</div>
    </header-top>
    <div class="privacy-wrapperQd">
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; line-height:22pt; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">为确保{{ appName }}相关业务功能的正常实现，我们需要根据具体的业务场景调用对应的系统权限并在调用前向您弹窗询问。</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; line-height:22pt; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">以下列表展示我们可能会申请、使用的设备权限。随着{{ appName }}的升级，如我们申请或使用的设备权限类型、目的发生变动的，我们将及时更新列表。</span>
        </p>
        <p style="text-indent:33pt; font-size:12pt"><span style="font-family:宋体; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border-insideh:0.75pt single #000000; -aw-border-insidev:0.75pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:77.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">设备权限</span></p>
                </td>
                <td
                    style="width:130.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">权限功能说明</span></p>
                </td>
                <td
                    style="width:138.95pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">权限使用场景或目的</span></p>
                </td>
                <td
                    style="width:64.4pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">是否可关闭</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">麦克风权限</span></p>
                </td>
                <td style="width:130.4pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">使用麦克风录制音频</span></p>
                </td>
                <td style="width:138.95pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">完成音视频录制及语音/视频速配及语音聊天相关功能</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">存储权限</span></p>
                </td>
                <td style="width:130.4pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">读取/写入设备外置存储器</span></p>
                </td>
                <td style="width:138.95pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">读取选定的照片/音视频等内容以实现更换头像、内容发布或保存{{ appName }}拍摄的图片/音视频、读取/存储日志信息</span>
                    </p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">位置权限</span></p>
                </td>
                <td style="width:130.4pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">通过全球定位系统<span style="font-weight:bold">（GPS）</span>或网络位置信息<span style="font-weight:bold">（如基站和WLAN）</span>获取设备所在的地理位置信息</span>
                    </p>
                </td>
                <td style="width:138.95pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用于完成基于地理位置的服务，推荐附近聊天室，发布信息或使用相关服务时展示地理位置信息</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">相机权限</span></p>
                </td>
                <td style="width:130.4pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">使用摄像头进行拍摄</span></p>
                </td>
                <td style="width:138.95pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">使用摄像头完成照片或视频拍摄</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">相册权限</span></p>
                </td>
                <td style="width:130.4pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">读取/写入相册信息</span></p>
                </td>
                <td style="width:138.95pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">读取/上传/下载照片/视频等数据以实现更换头像、内容发布或保存{{ appName }}拍摄的图片/音视频</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">传感器权限</span></p>
                </td>
                <td style="width:130.4pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">访问加速度、陀螺仪、距离感应等传感器数据</span></p>
                </td>
                <td style="width:138.95pt; border-style:solid; border-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">获取设备状态（方向、角度、加速度等）用于拍摄时调整画面角度</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">通知权限</span></p>
                </td>
                <td
                    style="width:130.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">系统通知</span></p>
                </td>
                <td
                    style="width:138.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">完成各类消息通知推送</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:77.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">悬浮窗权限</span></p>
                </td>
                <td
                    style="width:130.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">将小窗画面悬浮于其他内容之上</span></p>
                </td>
                <td
                    style="width:138.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">使用语音房、视频房、进行音视频通话功能时通过悬浮窗小窗展示其内容</span></p>
                </td>
                <td
                    style="width:64.4pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top">
                    <p class="dingdocnormal" style="line-height:22pt; widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">是</span></p>
                </td>
            </tr>
        </table>
        <p><span style="-aw-import:ignore">&#xa0;</span></p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
del {
  display: none;
}
ins {
  text-decoration: none;
}
.tabOther {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  table-layout: fixed;
  word-break: break-all;
  tr {
    font-size: 16px;
    .tr7 {
      word-break: break-all;
    }
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
  padding-bottom: 130px;
}
.privacy-wrapperQd {
  padding-top: 120px;
  padding: 120px 10px 0;
  width: 730px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "Privacy",
  data() {
    return {
      appName: this.$store.state.appName
    };
  },
  mounted() {
    console.log("appName:", this.appName);
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  }
};
</script>
